import { keyframes } from '@emotion/css';

export const pulse = keyframes`
  0% {
    opacity: 0;
  }
  20%, 24% {
    opacity: 1;
  }
  65%, 100% {
    opacity: 0;
  }
`;

export const reveal = keyframes`
  to {
    opacity: 1;
    visibility: visible;
    transform: none;
  }
`;

export const shake = keyframes`
  20% { transform: translateX(-4px); }
  40% { transform: translateX(4px); }
  60% { transform: translateX(-6px); }
  80% { transform: translateX(0); }
`;

export const popup = keyframes`
  from {
    opacity: 0.3;
    transform: scale(0);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;
